import type { IAppActivitySource } from "@frontend-shared/utils";

// NOTE: NSAI-5910 — the browser's answer to "is the user looking at the app?"
// for the sockets' auth recovery (SocketAuthRecovery). A hidden tab is not;
// when it becomes visible again, regains focus or the network, the listener
// runs — but only while the tab is visible, so a socket parked in a background
// tab is never retried unseen. Routine pointer and keyboard input deliberately
// do not count: those events must not bypass a pending retry's backoff.
const WINDOW_RETURN_EVENTS = ["focus", "online"] as const;

const isDocumentVisible = (): boolean =>
  globalThis.document?.visibilityState !== "hidden";

export const browserActivitySource: IAppActivitySource = {
  isActive: isDocumentVisible,
  subscribe: (listener: () => void): (() => void) => {
    if (globalThis.window === undefined) {
      return () => undefined;
    }

    const handleActivity = (): void => {
      if (isDocumentVisible()) {
        listener();
      }
    };

    globalThis.document.addEventListener("visibilitychange", handleActivity);
    for (const eventName of WINDOW_RETURN_EVENTS) {
      globalThis.window.addEventListener(eventName, handleActivity);
    }

    return () => {
      globalThis.document.removeEventListener(
        "visibilitychange",
        handleActivity,
      );
      for (const eventName of WINDOW_RETURN_EVENTS) {
        globalThis.window.removeEventListener(eventName, handleActivity);
      }
    };
  },
};
